import axios from 'axios'
import { environment } from '@/data/environment/'

function downloadFile (response, fileName) {
  const url = window.URL.createObjectURL(
    new Blob([response.data]),
  )

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export default {

  namespaced: true,

  state: {

    configs: [],

    stores: [],

    statusResponse: false,

  },

  mutations: {

    setConfigs (state, data) {
      state.configs = data
    },

    setStores (state, data) {
      state.stores = data
    },

    setStatusResponse (state, data) {
      state.statusResponse = data
    },

  },

  actions: {

    // ==========================================================
    // ALIANZAS
    // ==========================================================

    getConfigs ({ commit }) {
      const endpoint =
        '/api/alianzas/config'

      const url =
        environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .get(url)
        .then(response => {
          commit(
            'setConfigs',
            response.data.data || [],
          )

          return response
        })
    },

    saveConfig ({ commit }, data) {
      const endpoint =
        '/api/alianzas/config'

      const url =
        environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .post(url, data)
        .then(response => {
          commit(
            'setStatusResponse',
            response.data,
          )

          return response
        })
    },

    updateConfig ({ commit }, data) {
      const endpoint =
        '/api/alianzas/config/' +
        data.id

      const url =
        environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .put(url, data)
        .then(response => {
          commit(
            'setStatusResponse',
            response.data,
          )

          return response
        })
    },

    // ==========================================================
    // CODE STORES
    // ==========================================================

    getStores ({ commit }, idAlianza) {
      const endpoint =
        '/api/alianzas/config/' +
        idAlianza +
        '/stores'

      const url =
        environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .get(url)
        .then(response => {
          commit(
            'setStores',
            response.data.data || [],
          )

          return response
        })
    },

    saveStore ({ commit }, data) {
      const endpoint =
        '/api/alianzas/config/' +
        data.IdAlianza +
        '/stores'

      const url =
        environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .post(url, {
          CodeStore: data.CodeStore,
        })
        .then(response => {
          commit(
            'setStatusResponse',
            response.data,
          )

          return response
        })
    },

    changeStoreStatus ({ commit }, data) {
      const endpoint =
        '/api/alianzas/stores/' +
        data.Id +
        '/status'

      const url =
        environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .put(url, {

          Active:
          data.Active,

        })
        .then(response => {
          commit(
            'setStatusResponse',
            response.data,
          )

          return response
        })
    },

    downloadAuditLogs (context, payload) {
      return axios({
        url:
          environment.HIOPOSWEBSERVICES +
          '/api/alianzas/audit/logs/' +
          payload.company.IdCompania,
        method: 'GET',
        params: {
          from: payload.from,
          to: payload.to,
          codigoAlianza: payload.company.CodigoAlianza,
        },
      }).then(response => {
        downloadFile(
          {
            data: JSON.stringify(response.data, null, 2),
          },
          `alianza_${payload.company.CodigoAlianza}_logs_${payload.from}_${payload.to}.json`,
        )
      })
    },

    downloadAuditReport (context, payload) {
      return axios({
        url:
          environment.HIOPOSWEBSERVICES +
          '/api/alianzas/audit/report/' +
          payload.company.IdCompania,
        method: 'GET',
        responseType: 'blob',
        params: {
          from: payload.from,
          to: payload.to,
          codigoAlianza: payload.company.CodigoAlianza,
        },
      }).then(response => {
        downloadFile(
          response,
          `alianza_${payload.company.CodigoAlianza}_reporte_${payload.from}_${payload.to}.xlsx`,
        )
      })
    },

  },

}
